export default "__VITE_ASSET__P$siU1_m__"